module.exports = __webpack_public_path__ + "fonts/font.9479e0b5.ttf";